import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import styles from "./Auth.module.css";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const nav = useNavigate();

  const submit = async (e: any) => {
    e.preventDefault();
    try {
      const r = await axios.post(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/auth/signup",
        { name, email, password }
      );

      localStorage.setItem("bni_token", r.data.token);
      localStorage.setItem("bni_user", JSON.stringify(r.data.user));

      nav("/profile");
      window.location.reload();
    } catch (err: any) {
      alert(err.response?.data?.message || "Signup failed");
    }
  };

  return (
    <div className={styles.authWrapper}>
      <div className={styles.card}>
        <h2 className={styles.title}>Create Your Account</h2>
        <p className={styles.subtitle}>Join BNI Brisk and grow your network</p>

        <form onSubmit={submit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Name</label>
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your full name"
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Create a strong password"
            />
          </div>

          <button type="submit" className={styles.btnPrimary}>
            Create Account
          </button>

          <div className={styles.footerText}>
            Already a member? <Link to="/auth/login">Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
